import CommonTable from "components/CommonComponents/ReactTable/Table";
import { DEFAULT_RECORDS_PER_PAGE } from "components/constant";
import React, { useState } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Input,
  UncontrolledTooltip,
} from "reactstrap";
import Select, { components } from "react-select";
import { fixedWidthCustomStyle } from "constants/CommonConstants";
import {
  CERTIFICATE_STATUS,
  CERTIFICATE_TYPE,
  COURSE_LEVELS,
} from "components/constant";
import CommonModal from "components/CommonComponents/CommonModal";
import { downloadImage } from "./TraineeDetails";

function TraineeCertificates() {
  const [pageNum, setPageNum] = useState(1);
  const [filterState, setFilterState] = useState({
    searchName: "",
    searchStatus: null,
    filterParams: [],
  });
  const [preview, setPreview] = useState({
    isOpen: false,
    image: "",
  });

  const columns = [
    {
      Header: "Sr. No.",
      accessor: "id",
    },
    {
      Header: "Certificate Number",
      accessor: "certNumber",
    },
    {
      Header: "Type",
      accessor: "type",
    },
    {
      Header: "Course Name",
      accessor: "courseName",
    },
    {
      Header: "Level",
      accessor: "level",
    },
    {
      Header: "Issue Date",
      accessor: "issueDate",
    },
    {
      Header: "Validity Till",
      accessor: "validTill",
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ value }) => (
        <Badge
          color={
            value === "Issued"
              ? "success"
              : value === "Expired"
                ? "warning"
                : "secondary"
          }
          pill
        >
          {value}
        </Badge>
      ),
    },
    {
      Header: "Actions",
      disableSortBy: true,
      Cell: ({ row }) => {
        return (
          <div className="d-flex">
            <Button
              className="btn-link d-flex align-items-center p-0"
              id={`details${row.original.id}`}
              size="sm"
              onClick={() => handleViewCertificate(row.original)}
            >
              <i className="fas fa-eye mr-1 table-action-primary" />
            </Button>
            <UncontrolledTooltip target={`details${row.original.id}`}>
              View
            </UncontrolledTooltip>

            <Button
              className="btn-link d-flex align-items-center p-0"
              id={`download${row.original.id}`}
              size="sm"
              onClick={() => handleDowmloadCertificate(row.original)}
            >
              <i class="fa-solid fa-lg fa-download"></i>
            </Button>
            <UncontrolledTooltip target={`download${row.original.id}`}>
              Download
            </UncontrolledTooltip>
          </div>
        );
      },
    },
  ];

  const certificatesList = [
    {
      id: 1,
      certNumber: "CERT-ES-2025-001",
      type: "Individual",
      courseName: "Electrical Safety",
      level: "Beginner",
      issueDate: "25 Jan 2025, 10:30 PM",
      validTill: "24 Jan 2028, 11:59 AM",
      status: "Issued",
    },
    {
      id: 2,
      certNumber: "CERT-IW-2025-002",
      type: "Individual",
      courseName: "Industrial Wiring Basics",
      level: "Beginner",
      issueDate: "30 Jan 2025, 02:15 PM",
      validTill: "29 Jan 2028, 11:59 PM",
      status: "Issued",
    },
    {
      id: 3,
      certNumber: "CERT-SO-2025-003",
      type: "Individual",
      courseName: "Substation Operations",
      level: "Intermediate",
      issueDate: "02 Feb 2025, 09:00 PM",
      validTill: "01 Feb 2028, 11:59 PM",
      status: "Issued",
    },
    {
      id: 4,
      certNumber: "CERT-EM-2025-004",
      type: "Individual",
      courseName: "Energy Management Basics",
      level: "Beginner",
      issueDate: "05 Feb 2025, 11:45 PM",
      validTill: "04 Feb 2028, 11:59 PM",
      status: "Issued",
    },
    {
      id: 5,
      certNumber: "CERT-AES-2025-005",
      type: "Individual",
      courseName: "Advanced Electrical Safety",
      level: "Advanced",
      issueDate: "10 Feb 2025, 04:20 PM",
      validTill: "09 Feb 2028, 11:59 AM",
      status: "Pending",
    },
    {
      id: 6,
      certNumber: "GCERT-GOF-2025-006",
      type: "Group",
      courseName: "Grid Operations Fundamentals",
      level: "Beginner",
      issueDate: "12 Feb 2025, 01:10 PM",
      validTill: "11 Feb 2028, 11:59 PM",
      status: "Expired",
    },
  ];

  // Custom Option Renderer
  const Option = (props) => {
    return (
      <components.Option {...props}>
        <Badge
          color={
            props.data.value === "ISSUED"
              ? "success"
              : props.data.value === "EXPIRED"
                ? "warning"
                : "secondary"
          }
          pill
        >
          {props.data.label}
        </Badge>
      </components.Option>
    );
  };

  // Custom SingleValue Renderer (for the selected value)
  const SingleValue = (props) => {
    return (
      <components.SingleValue {...props}>
        <Badge
          color={
            props.data.value === "ISSUED"
              ? "success"
              : props.data.value === "EXPIRED"
                ? "warning"
                : "secondary"
          }
          pill
        >
          {props.data.label}
        </Badge>
      </components.SingleValue>
    );
  };

  const handleViewCertificate = (rowData) => {
    setPreview({
      isOpen: true,
      image: require("assets/img/certificates/template2.jpg"),
    });
  };

  const handlePreviewCancel = () => {
    setPreview({
      isOpen: false,
      image: "",
    });
  };

  const handleDowmloadCertificate = (rowData) => {
    downloadImage(
      require("assets/img/certificates/template2.jpg"),
      "Certificate-1.jpg",
    );
  };

  return (
    <Card className="mb-6">
      {/*<CardHeader>
         <h4 className="mb-0">Enrolled Courses</h4> 
      </CardHeader>*/}
      <CardBody className="p-4">
        <div className="mb-3"> (Static Data)</div>
        <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap flex-column flex-md-row">
          <div className="d-flex flex-wrap align-items-center filter-group">
            <Input
              placeholder="Search by cert number"
              className="mr-2 mb-2 filter-select"
            />

            <Input
              placeholder="Search by course name"
              className="mr-2 mb-2 filter-select"
            />

            <div className="d-flex mr-2 mb-2 align-items-center date-range-wrapper">
              <span className="mr-2">Validity Till</span>
              <Input type="date" className="mr-1 filter-select" />
              {/* <span className="mx-1">To</span>
              <Input type="date" className="ml-1 mb-1 filter-select" /> */}
            </div>

            <Select
              className="mr-2 mb-2 filter-select"
              options={CERTIFICATE_TYPE}
              placeholder="Certificate type"
              classNamePrefix="react-select"
              styles={fixedWidthCustomStyle()}
            />

            <Select
              className="mr-2 mb-2 filter-select"
              options={COURSE_LEVELS}
              placeholder="Course level"
              classNamePrefix="react-select"
              styles={fixedWidthCustomStyle()}
            />

            <Select
              className="mr-2 mb-2 filter-select"
              options={CERTIFICATE_STATUS}
              placeholder="Select Status"
              classNamePrefix="react-select"
              styles={fixedWidthCustomStyle()}
              components={{ Option, SingleValue }}
              value={filterState.searchStatus}
              onChange={(selected) =>
                setFilterState((prev) => ({
                  ...prev,
                  searchStatus: selected,
                }))
              }
            />

            <Button
              color="default"
              className="d-flex align-items-center mb-2 filter-btn btn-deep-blue"
            >
              <i className="fa fa-search mr-1" />
              Search
            </Button>
          </div>
        </div>
        <div className="mt-2 mb-3 mx-1">
          <span className="total-records">
            Total Records : {certificatesList.length}
          </span>
        </div>
        <CommonTable
          columns={columns}
          data={certificatesList || []}
          defaultPageSize={DEFAULT_RECORDS_PER_PAGE}
          activePage={pageNum}
          setPageNum={setPageNum}
          totalPages={Math.ceil(
            certificatesList.length / DEFAULT_RECORDS_PER_PAGE,
          )}
          showPaginationBottom={true}
        />
      </CardBody>
      <CommonModal
        isOpen={preview.isOpen}
        toggle={handlePreviewCancel}
        title="Certificate Preview"
        size="xl"
      >
        <div className="text-center p-0 pb-2">
          <img
            src={preview.image}
            alt="Certificate Preview"
            className="img-fluid pb-3"
          />
        </div>
      </CommonModal>
    </Card>
  );
}

export default TraineeCertificates;
